import React, {ReactNode} from 'react';
import {Button} from 'antd';
import {SizeType} from 'antd/lib/config-provider/SizeContext';
import './styles.style.less';

type Props = {
  text?: string;
  type?:
    | 'text'
    | 'link'
    | 'ghost'
    | 'default'
    | 'primary'
    | 'dashed'
    | undefined;
  onClickAction?: Function;
  icon?: ReactNode;
  size?: SizeType;
  styles?: Object;
  className?: string;
  loading?: boolean;
  danger?: boolean;
  disabled?: boolean;
};

const ButtonComponent = ({
  text,
  type,
  onClickAction,
  icon,
  size,
  styles,
  loading,
  className,
  danger,
  disabled,
}: Props) => {
  return (
    <Button
      type={type}
      onClick={onClickAction ? () => onClickAction() : undefined}
      icon={icon}
      size={size}
      className={`buttonRow ${className}`}
      loading={loading}
      style={styles}
      disabled={disabled}
      danger={danger}>
      <div>{text}</div>
    </Button>
  );
};

export default ButtonComponent;
